import { PrivateRouteObject, SHARED_ROUTES } from 'navigation/routes'
import { lazy } from 'react'

const Notes = lazy(() => import('containers/RegulatoryBody/Notes'))
const Profile = lazy(() => import('containers/RegulatoryBody/Profile'))
const NoteDetails = lazy(() => import('containers/RegulatoryBody/NoteDetails'))
const Dashboard = lazy(() => import('containers/RegulatoryBody/Dashboard'))
const Notifications = lazy(() => import('containers/RegulatoryBody/Notifications'))
const RealEstateAssetDetailView = lazy(() => import('containers/RealEstateAssetDetailView'))
const RealEstateAssets = lazy(() => import('containers/RegulatoryBody/RealEstateAssets'))
const MasterBonds = lazy(() => import('containers/RegulatoryBody/MasterAssets'))
const MasterBondDetailView = lazy(() => import('containers/MasterAssetDetailView'))
const RegulatoryBonds = lazy(() => import('containers/RegulatoryBody/Bonds'))
const BondDetailView = lazy(() => import('containers/BondDetailView'))

export const REGULATORY_ROUTES: PrivateRouteObject[] = [
  {
    exact: true,
    title: 'My Dashboard',
    path: '/auth/my-dashboard',
    component: Dashboard
  },
  {
    exact: true,
    title: 'My Notes',
    path: '/auth/notes',
    component: Notes
  },
  {
    exact: true,
    title: 'Real Estate Assets',
    path: '/auth/real-estate-assets',
    component: RealEstateAssets
  },
  {
    exact: true,
    title: 'My Profile',
    path: '/auth/profile',
    component: Profile
  },
  {
    exact: true,
    title: 'Notifications',
    path: '/auth/notifications',
    component: Notifications
  },
  {
    exact: true,
    title: 'My Real Estate Asset Details',
    path: '/auth/my-real-estate-assets/:view/:id',
    component: RealEstateAssetDetailView
  },
  {
    exact: true,
    title: 'Note View',
    path: '/auth/notes/:id',
    component: NoteDetails
  },
  {
    exact: true,
    title: 'Master Bonds',
    path: '/auth/master-bonds',
    component: MasterBonds
  },
  {
    exact: true,
    title: 'Master Bond Details',
    path: '/auth/my-master-bonds/:view/:id',
    component: MasterBondDetailView
  },
  {
    exact: true,
    title: 'Bonds',
    path: '/auth/bonds',
    component: RegulatoryBonds
  },
  {
    exact: true,
    title: 'Bond Details',
    path: '/auth/my-bonds/:view/:id',
    component: BondDetailView
  },
  ...SHARED_ROUTES
]
